import Icon from '@ant-design/icons';
import { Button, Col, Form, FormInstance, Input, message, Row } from 'antd';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Link, RouteComponentProps } from 'react-router-dom';
import collegeApi from '../../../../apis/CollegeApi';
import LayoutComponent from '../../../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../../../context/CustomContext';
import { College } from '../../../../model/Entities';
import { ReactComponent as SaveSvg } from '../../../../resources/images/ico-save.svg';
import { ReactComponent as DeleteSvg } from '../../../../resources/images/ico-delete.svg';
import notificationService from '../../../../services/NotificationService';
import styles from './CollegePage.module.scss';

class CollegePage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;
    formRef = React.createRef<FormInstance>();

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            this.setState({ loading: true });
            if (this.props.match.params.id === 'new') {
                await this.new();
            } else {
                await this.get(+this.props.match.params.id);
            }
        } catch (error) {
        } finally {
            this.setState({ loading: false });
        }
    };

    new = async () => {
        const college: College = {
            division: '',
        };

        this.setState({ college });
        this.formRef.current!.setFieldsValue(college);
    };

    get = async (id: number) => {
        const college = await collegeApi.get(id);

        this.setState({ college });
        this.formRef.current!.setFieldsValue(college);
    };

    save = async (values: any) => {
        try {
            this.setState({ loading: true });
            let college: College = Object.assign({}, this.state.college, values);
            college = college.id ? await collegeApi.update(college) : await collegeApi.create(college);
            message.success(this.props.intl.formatMessage({ id: 'status.saved' }));

            this.setState({ college });
        } catch (error) {
            notificationService.displayError(error, this.props.intl, [
                { status: 409, message: 'college.status.duplicate' },
            ]);
        } finally {
            this.setState({ loading: false });
        }
    };

    delete = async () => {
        const { college } = this.state;
        try {
            this.setState({ loading: true });
            await collegeApi.delete(college!);
            this.props.history.push(`/admin/colleges`);
        } catch (error) {
            notificationService.displayError(error, this.props.intl);
        } finally {
            this.setState({ loading: false });
        }
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        const { loading } = this.state;

        return (
            <>
                {this.renderToolbar()}
                <Form ref={this.formRef} onFinish={this.save} colon={false} layout="vertical">
                    <Row gutter={[28, 0]}>
                        <Col xs={24} md={8}>
                            <Form.Item label={<FormattedMessage id="college.school" />} name="school">
                                <Input maxLength={100} size="large" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={8}>
                            <Form.Item label={<FormattedMessage id="college.division" />} name="division">
                                <Input maxLength={100} size="large" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col xs={24} md={8}>
                            <Form.Item label={<FormattedMessage id="college.athleticWebsite" />} name="athleticWebsite">
                                <Input maxLength={100} size="large" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={8}>
                            <Form.Item label={<FormattedMessage id="college.staffDirectory" />} name="staffDirectory">
                                <Input maxLength={100} size="large" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[28, 0]}>
                        <Col xs={24} md={8}>
                            <Form.Item label={<FormattedMessage id="college.admissionLink" />} name="admissionLink">
                                <Input maxLength={100} size="large" />
                            </Form.Item>
                        </Col>
                    </Row>

                    <div className={styles.buttons}>
                        <Link to="/admin/colleges">
                            <Button size="large" className={styles.back}>
                                <FormattedMessage id="college.back" />
                            </Button>
                        </Link>
                        {this.props.match.params.id !== 'new' && (
                            <Button
                                size="large"
                                icon={<Icon component={DeleteSvg} />}
                                className={styles.delete}
                                onClick={() => this.delete()}
                            >
                                <FormattedMessage id="college.delete" />
                            </Button>
                        )}
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            className={styles.save}
                            icon={<Icon component={SaveSvg} />}
                            loading={loading}
                        >
                            <FormattedMessage id="college.save" />
                        </Button>
                    </div>
                </Form>
            </>
        );
    };

    renderToolbar = (): React.ReactElement | undefined => {
        if (this.props.match.params.id === 'new') {
            return (
                <div className={styles.toolbar}>
                    <h1>
                        <FormattedMessage id="colleges.addtitle" />
                    </h1>
                </div>
            );
        } else {
            return (
                <div className={styles.toolbar}>
                    <h1>
                        <FormattedMessage id="colleges.edittitle" />
                    </h1>
                </div>
            );
        }
    };

    render() {
        return <LayoutComponent page="edit-college" content={this.renderContent} />;
    }
}
export default injectIntl(CollegePage);

type ParamsType = { id: string };
interface Props extends RouteComponentProps<ParamsType>, WrappedComponentProps {}

interface State {
    college?: College;
    loading?: boolean;
}
